import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { API_BO } from '../conf'
import * as menu from '../pages/menu/index'
import * as adminPanel from '../pages/adminPanel/index'

const pAdmin = API_BO + '/a-panel'
const pTariff = pAdmin + '/tariff'
const pRegion = pAdmin + '/regions'
const pSpecializations = pAdmin + '/specializations'
const pPayments = pAdmin + '/payments'
const pAccountT = pAdmin + '/accounts'
const pJournalTypes = pAdmin + '/journal_types'
const pJournalCategories = pAdmin + '/journal_categories'
const pSystems = pAdmin + '/systems'
const pRoles = pAdmin + '/roles'
const pOKEI = pAdmin + '/okei'

const ADD = '/add';

export default function RoutAdmin() {
  const g = localStorage.getItem('g')
  if (g === 'false') return <></>
  return <Switch>
    <Route exact path={pAdmin} children={<menu.admin />} />

    <Route exact path={pTariff} children={<adminPanel.tariffList />} />
    <Route exact path={pTariff + ADD} children={<adminPanel.tariffAdd />} />
    <Route exact path={pTariff + '/:idDoc'} children={<adminPanel.tariffOne />} />

    <Route exact path={pPayments} children={<adminPanel.paymentsList />} />
    <Route exact path={pPayments + ADD} children={<adminPanel.paymentsAdd />} />

    <Route exact path={pAccountT} children={<adminPanel.accountList />} />
    <Route exact path={pAccountT + ADD} children={<adminPanel.accountAdd />} />
    <Route exact path={pAccountT + '/:idDoc'} children={<adminPanel.accountOne />} />
    <Route exact path={pAccountT + '/:idDoc/edit'} children={<adminPanel.accountEdit />} />
    <Route exact path={pAccountT + '/:idDoc/:idTariff'} children={<adminPanel.accountTariffEdit />} />

    <Route exact path={pRegion} children={<adminPanel.regionList />} />
    <Route exact path={pRegion + ADD} children={<adminPanel.regionAdd />} />
    <Route exact path={pRegion + '/:idDoc'} children={<adminPanel.regionOne />} />

    <Route exact path={pSpecializations} children={<adminPanel.specializationList />} />
    <Route exact path={pSpecializations + ADD} children={<adminPanel.specializationAdd />} />
    <Route exact path={pSpecializations + '/:idDoc'} children={<adminPanel.specializationOne />} />

    <Route exact path={pJournalTypes} children={<adminPanel.journalTypesList />} />
    <Route exact path={pJournalTypes + ADD} children={<adminPanel.journalTypesAdd />} />
    {/* <Route exact path={pJournalTypes + '/:idDoc'} children={<adminPanel />} /> */}

    <Route exact path={pJournalCategories} children={<adminPanel.journalCategoriesList />} />
    <Route exact path={pJournalCategories + ADD} children={<adminPanel.journalCategoriesAdd />} />
    {/* <Route exact path={pJournalCategories + '/:idDoc'} children={<adminPanel />} /> */}

    <Route exact path={pSystems} children={<adminPanel.systemsList />} />
    <Route exact path={pSystems + ADD} children={<adminPanel.systemsAdd />} />
    {/* <Route exact path={pSystems + '/:idDoc'} children={<adminPanel />} /> */}

    <Route exact path={pRoles} children={<adminPanel.rolesList />} />
    <Route exact path={pRoles + ADD} children={<adminPanel.rolesAdd />} />
    <Route exact path={pRoles + '/:idDoc'} children={<adminPanel.rolesOne />} />

    <Route exact path={pOKEI} children={<adminPanel.okeiList />} />
    <Route exact path={pOKEI + '/upload'} children={<adminPanel.okeiUpload />} />
    <Route exact path={pOKEI + '/not'} children={<adminPanel.okeiNotList />} />
  </Switch>
}

